module.exports = __webpack_public_path__ + "img/dashboard.2d3abcaf.png";